import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "labos-page" }

import HeaderNav from '@/components/LabOS/HeaderNav.vue'
import SidebarNav from '@/components/LabOS/SidebarNav.vue'
import HeroSection from '@/components/LabOS/HeroSection.vue'
import AboutSection from '@/components/LabOS/AboutSection.vue'
import UseLabOSSection from '@/components/LabOS/UseLabOSSection.vue'
import MediaSection from '@/components/LabOS/MediaSection.vue'
import BenchmarkSection from '@/components/LabOS/BenchmarkSection.vue'
import LeaderboardSection from '@/components/LabOS/LeaderboardSection.vue'
import TeamSection from '@/components/LabOS/TeamSection.vue'
import FooterSection from '@/components/LabOS/FooterSection.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'LabOSView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderNav),
    _createVNode(SidebarNav),
    _createVNode(HeroSection),
    _createVNode(AboutSection),
    _createVNode(UseLabOSSection),
    _createVNode(BenchmarkSection),
    _createVNode(LeaderboardSection),
    _createVNode(MediaSection),
    _createVNode(TeamSection),
    _createVNode(FooterSection)
  ]))
}
}

})